import { Dialog, Button, DialogContent, DialogActions, DialogContentText, Alert , DialogTitle} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
  isOpen: boolean;
  handleClose: () => void;
  severity: any;
  handleOk: () => void;
  title?: string;
}

export const DeleteDialog: React.FC<Props> = ({ text, isOpen, handleClose, severity, handleOk, title="" }) => {
  // Note: Material ui severity types 'error','info','success', 'warning'
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {!!title.length && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Alert severity={severity}>{text}</Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} autoFocus size="small">
          {t('misc.no')}
        </Button>
        <Button variant="contained" onClick={handleOk} autoFocus size="small">
          {t('misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
